import { render } from "./LiveDentalAdvisory.vue?vue&type=template&id=1ca8e34a&scoped=true"
import script from "./LiveDentalAdvisory.vue?vue&type=script&lang=js"
export * from "./LiveDentalAdvisory.vue?vue&type=script&lang=js"

import "./LiveDentalAdvisory.vue?vue&type=style&index=0&id=1ca8e34a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca8e34a"]])

export default __exports__